/* eslint-disable jsx-a11y/no-redundant-roles */
import React from 'react'

import StepperCircle from 'components/Common/SvgIcons/StepperCircle'

const timeline = [
  {
    id: 1,
    content: 'Assesment',
    icon: StepperCircle,
  },
  {
    id: 2,
    content: 'Step 1',
    icon: StepperCircle,
  },
  {
    id: 3,
    content: 'Step 2',
    icon: StepperCircle,
  },
]

export default function GoalStepper() {
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <>
      <button
        type="button"
        className="inline-block relative top-[8px] z-index-10 px-6 py-2.5 h-[45px] w-[116px]  bg-silver-darker text-white font-medium text-[16px] font-medium leading-tight uppercase
                rounded-t ease-in-out"
      >
        Steps
      </button>
      <div className="w-full relative p-4">
        <ul role="list" className="-mb-8">
          {timeline.map((event, eventIdx) => (
            <li key={event.id}>
              <div className="relative pb-8">
                {eventIdx !== timeline.length - 1 ? (
                  <span
                    className="absolute top-7 left-4 -ml-px h-full w-0.5 bg-black"
                    aria-hidden="true"
                  />
                ) : null}
                <div className="relative flex space-x-3">
                  <div>
                    <span
                      className={classNames(
                        'h-8 w-8 rounded-full flex items-center justify-center '
                      )}
                    >
                      <event.icon
                        className="h-10 bg-white z-index-10 w-10 text-white"
                        aria-hidden="true"
                      />
                    </span>
                  </div>
                  <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                    <div>
                      <p className="text-sm font-medium text-[#18181B]">{event.content} </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
